// extracted by mini-css-extract-plugin
export default {"badge":"RequirementsBadge_badge__EZeA1","clickable":"RequirementsBadge_clickable__uT25e","count":"RequirementsBadge_count__czSdk"};